<template>
  <v-container fluid fill-height class="d-flex justify-center align-center">
    <v-row justify="center" align="center" class="w-100">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6" elevation="12">
          <v-img
            src="@/assets/logo-oei-fli-fwi.png"
            alt="Logo"
            height="200px"
            class="mb-4"
            contain
          ></v-img>

          <!-- Form reset password -->
          <v-form v-model="valid" @submit.prevent="RequestResetPassword">
            <!-- Email input -->
            <v-text-field
              label="Email"
              v-model="email"
              :rules="[(v) => !!v || 'Email is required']"
              required
            ></v-text-field>

            <!-- Submit button -->
            <v-btn
              :disabled="!valid"
              type="submit"
              color="primary"
              class="ma-2"
              block
            >
              Send Reset Link
            </v-btn>
            <!-- Link ke halaman reset password -->
            <v-btn text @click="goToLogin" class="ma-2" block x-small>
              login ?
            </v-btn>
          </v-form>

          <!-- Snackbar error message -->
          <v-snackbar
            v-model="snackbar"
            color="error"
            top
            multi-line
            timeout="5000"
          >
            {{ errorMessage }}
            <v-btn color="white" @click="snackbar = false">Close</v-btn>
          </v-snackbar>

          <!-- Snackbar success message -->
          <v-snackbar
            v-model="successSnackbar"
            color="success"
            top
            multi-line
            timeout="5000"
          >
            {{ successMessage }}
            <v-btn color="white" @click="successSnackbar = false">Close</v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import axios from "axios";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    snackbarMessage,
  },
  data() {
    return {
      email: "",
      valid: false,
      snackbar: false,
      successSnackbar: false,
      errorMessage: "",
      successMessage: "Password reset link sent to your email!",
    };
  },
  methods: {
    RequestResetPassword() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/employees/request-reset-password`,
          {
            email: this.email,
          }
        )
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          this.email = "";
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          // console.error("Request reset password error:", error);
          let message = "Failed to Request Reset password!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        });
    },
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
